import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "data-testid": "helmop-resources-section" }
const _hoisted_2 = { class: "row mt-20 mb-20" }
const _hoisted_3 = { class: "col span-6" }
const _hoisted_4 = { class: "row mt-20 mb-20" }
const _hoisted_5 = { class: "col span-6" }
const _hoisted_6 = { class: "resource-handling" }

import { ref } from 'vue';
import { useI18n } from '@shell/composables/useI18n';
import { useHelmOpResources } from '@shell/composables/useHelmOpResources';
import { useStore } from 'vuex';
import Checkbox from '@components/Form/Checkbox/Checkbox.vue';
import FleetSecretSelector from '@shell/components/fleet/FleetSecretSelector.vue';
import FleetConfigMapSelector from '@shell/components/fleet/FleetConfigMapSelector.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'HelmOpResourcesSection',
  props: {
    value: {},
    mode: {},
    correctDriftEnabled: { type: Boolean },
    downstreamSecretsList: {},
    downstreamConfigMapsList: {}
  },
  emits: ["update:correct-drift", "update:downstream-resources"],
  setup(__props: any, { emit: __emit }) {



// eslint-disable-next-line func-call-spacing
const emit = __emit;

const store = useStore();
const { t } = useI18n(store);

const { updateCorrectDrift, updateSecrets, updateDownstreamResources } = useHelmOpResources(emit, ref([]));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(FleetSecretSelector, {
          value: __props.downstreamSecretsList,
          namespace: __props.value.metadata.namespace,
          mode: __props.mode,
          "data-testid": "helmop-resources-secret-selector",
          "onUpdate:value": _unref(updateSecrets)
        }, null, 8, ["value", "namespace", "mode", "onUpdate:value"])
      ])
    ]),
    _cache[3] || (_cache[3] = _createTextVNode()),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(FleetConfigMapSelector, {
          value: __props.downstreamConfigMapsList,
          namespace: __props.value.metadata.namespace,
          mode: __props.mode,
          "data-testid": "helmop-resources-configmap-selector",
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_unref(updateDownstreamResources)('ConfigMap', $event)))
        }, null, 8, ["value", "namespace", "mode"])
      ])
    ]),
    _cache[4] || (_cache[4] = _createTextVNode()),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(Checkbox, {
        value: __props.correctDriftEnabled,
        tooltip: _unref(t)('fleet.helmOp.resources.correctDriftTooltip'),
        type: "checkbox",
        "label-key": "fleet.helmOp.resources.correctDrift",
        mode: __props.mode,
        "data-testid": "helmop-resources-correct-drift",
        "onUpdate:value": _unref(updateCorrectDrift)
      }, null, 8, ["value", "tooltip", "mode", "onUpdate:value"]),
      _cache[2] || (_cache[2] = _createTextVNode()),
      _createVNode(Checkbox, {
        value: __props.value.spec.keepResources,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((__props.value.spec.keepResources) = $event)),
        tooltip: _unref(t)('fleet.helmOp.resources.keepResourcesTooltip'),
        type: "checkbox",
        "label-key": "fleet.helmOp.resources.keepResources",
        mode: __props.mode,
        "data-testid": "helmop-resources-keep-resources"
      }, null, 8, ["value", "tooltip", "mode"])
    ])
  ]))
}
}

})